import Obstacle from "./obstacle";
import * as THREE from "three";
import {Vector3} from "three";

export default class ObstacleManager {
    static init({scene, blueprints}){
        this.scene = scene;
        this.blueprints = blueprints;

        this.obstacles = [];

        const initialElements = 5;
        this.obstacleDistance = 10;
        this.spawnDistance = 10;
        const offset = 40;
        for(let i = 1; i < initialElements; i++){
            const obstacleLength = Math.floor(Math.random() * 4);
            this.lastElementZ = offset + i * this.obstacleDistance;
            if(obstacleLength <= 0) continue;
            const obstacle = this.spawnObstacle(this.lastElementZ, obstacleLength);
            this.obstacles.push(obstacle);
        }
        this.lastElementZ += this.obstacleDistance;
    }

    static spawnObstacle(z, length){
        let line;
        if(length >= 3){
            line = 1
        } else if (length === 2){
            line = Math.floor(Math.random() * 2);
            line += 0.5;
        } else {
            line = Math.floor(Math.random() * 3);
        }
        const position = new THREE.Vector3(-2 + 2 * line, 0, z);
        return this.createObstacle({
            blueprint: this.blueprints[length -1],
            position,
            length
        });
    }

    static moveZ(amount){
        this.spawnDistance += amount;
        if(this.spawnDistance <= this.obstacleDistance){
            const overflow = -this.spawnDistance;
            this.spawnDistance = this.obstacleDistance - overflow;
            const obstacleLength = Math.floor(Math.random() * 4);
            if(obstacleLength){
                const obstacle = this.spawnObstacle(this.lastElementZ, obstacleLength);
                this.obstacles.push(obstacle);
            }
        }

        const obstaclesToDelete = [];
        this.obstacles.forEach(o => {
            o.moveTo(
                new Vector3(
                    o.boundingBox.position.x,
                    o.boundingBox.position.y,
                    o.boundingBox.position.z + amount
                )
            )
            if(o.boundingBox.position.z < -10){
                obstaclesToDelete.push(o);
            }
        })
        this.obstacles = this.obstacles.filter(o => !obstaclesToDelete.includes(o));
        obstaclesToDelete.forEach(o => {
            o.destroy();
        })
        //console.log(this.obstacles.length);
    }

    static getObstacles(){
        return this.obstacles;
    }

    static createObstacle({position, blueprint, length}){
        return new Obstacle({
            scene: this.scene,
            blueprint,
            position,
            length,
        })
    }
}